var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewDefect(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.042 19.1027L19.5 21L18.958 19.1027C18.8179 18.6126 18.5553 18.1663 18.1948 17.8058C17.8344 17.4454 17.3881 17.1828 16.898 17.0427L15 16.5L16.8973 15.958C17.3874 15.8179 17.8337 15.5553 18.1942 15.1948C18.5546 14.8344 18.8172 14.3881 18.9573 13.898L19.5 12L20.042 13.8973C20.1821 14.3874 20.4447 14.8337 20.8052 15.1942C21.1656 15.5546 21.6119 15.8172 22.102 15.9573L24 16.5L22.1027 17.042C21.6126 17.1821 21.1663 17.4447 20.8058 17.8052C20.4454 18.1656 20.1828 18.6119 20.0427 19.102L20.042 19.1027Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8M2 7V16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21H17.2",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.8008V13.7856M8.5 14.5735H8.50218V14.5756H8.5V14.5735Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22298 15.4596L8.0278 10.4884C8.18282 10.2137 8.26032 10.0763 8.36145 10.0302C8.44965 9.98994 8.55035 9.98994 8.63855 10.0302C8.73968 10.0763 8.81718 10.2137 8.9722 10.4884L11.777 15.4596C11.9326 15.7353 12.0104 15.8732 11.9989 15.9864C11.9889 16.0851 11.9385 16.1747 11.8603 16.2331C11.7706 16.3 11.6153 16.3 11.3048 16.3H5.69518C5.38467 16.3 5.22942 16.3 5.13975 16.2331C5.06153 16.1747 5.01114 16.0851 5.00111 15.9864C4.98962 15.8732 5.0674 15.7353 5.22298 15.4596Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDefect);
export default __webpack_public_path__ + "static/media/NewDefect.38e6582c4fe725ef9df12731c20a97b6.svg";
export { ForwardRef as ReactComponent };